<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div v-if="showList">
    <img
      style="cursor: pointer; margin-bottom: 3px"
      src="../assets/back.png"
      @click="back"
    />
    <div v-if="this.foodCat != null">
      <div style="padding: 3px" class="titolo">
        {{ foodCat.description }}
      </div>
      <div
        style="display: flex; padding: 3px; "
        class="testobianco backgroudlist"
      >
        <div style="width: 75px">{{ COLNO }}</div>
        <div style="width: 75%">{{ COLNOMEALIM }}</div>
      </div>
      <div
        style="display: flex; padding: 3px"
        class="testonormale"
        v-for="(food, idx) in foodCat.foods"
        :key="food.idFood"
        :class="!iseven(idx) ? 'even' : ''"
        @click="selectFood(food)"
      >
        <div style="width: 75px">{{ food.idFoodShort }}</div>
        <div style="width: 75%" class="link">{{ food.description }}</div>
      </div>
    </div>
  </div>
  <FoodComponent
    v-if="showDetail && currentFoodId"
    :id="currentFoodId"
    :language="lang"
    @error="onError"
    @back="onBack"
  ></FoodComponent>
</template>
  
  <script>
import api from "../js/apiConsts.js";
import { axiosPost } from "../js/apiService.js";
import LoaderComponent from "./LoaderComponent.vue";
import FoodComponent from "@/components/FoodComponent.vue";
import { getSTRING } from "@/js/utils";
import apiConsts from "../js/apiConsts.js";
export default {
  name: "FoodGroupComponent",
  props: ["lang", "idGroup"],
  emits: { back: null, error: null },
  components: {
    LoaderComponent,
    FoodComponent,
  },
  data() {
    return {
      language: this.lang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
      foodCat: null,
      loadingData: false,
      showDetail: false,
      showList: true,
      currentFoodId: null,
      COLNOMEALIM: "",
      COLNO: "",
      TITOLO: "",
    };
  },
  async mounted() {
    await this.loadFoodDetail();
    this.TITOLO = getSTRING(this.lang, "TITOLO", apiConsts.TITOLOAPP);
    this.COLNOMEALIM = getSTRING(this.lang, "COLNOMEALIM", "Nome Alimento");
    this.COLNO = getSTRING(this.lang, "COLNO", "No.");
  },
  methods: {
    back() {
      this.$emit("back");
    },
    onBack() {
      this.showDetail = false;
      this.showList = true;
      this.currentFoodId = null;
    },
    selectFood(food) {
      this.currentFoodId = food.idFood;
      this.showDetail = true;
      this.showList = false;
    },
    onError(message){
      this.$emit('error', message);
    },
    iseven(num) {
      return num % 2 == 0;
    },
    async loadFoodDetail() {
      this.loadingData = true;
      await axiosPost(api.APISearchFoodByCategory, {
        language: this.language,
        foodCategory: this.idGroup,
      })
        .then((response) => {
          this.loadingData = false;
          let res = response.data;
          this.foodCat = null;
          if (res.success) {
            this.foodCat = res.foodCategory;
          } else {
            this.$emit('error', res.message);
          }
        })
        .catch((err) => {
          this.loadingData = false;
          this.$emit('error', err.message);
        });
    },
  },
};
</script>
  
  <style scoped>
.even {
  background-color: azure;
}
</style>